import type { Infer } from 'superstruct';
import { object } from 'superstruct';

import { DataTableItemType } from './data-table-item-type';

export const ListColumnTemplateQueryDto = object({
	columnTemplateType: DataTableItemType,
});

export type ListColumnTemplateQueryDto = Infer<
	typeof ListColumnTemplateQueryDto
>;
